var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97692 7.39942C9.87905 6.49569 9.87905 5.03215 8.97692 4.12842L6.52292 1.67742C5.61964 0.774192 4.15519 0.774192 3.25192 1.67742L1.90692 3.02342C0.74011 4.18838 0.556457 6.01445 1.46792 7.38842C5.42882 13.3503 10.54 18.4615 16.5019 22.4224C17.8762 23.3326 19.7012 23.1499 20.8679 21.9854L22.2129 20.6394C22.6469 20.2058 22.8908 19.6174 22.8908 19.0039C22.8908 18.3904 22.6469 17.8021 22.2129 17.3684L19.7599 14.9154C19.3263 14.4814 18.7379 14.2376 18.1244 14.2376C17.5109 14.2376 16.9226 14.4814 16.4889 14.9154L15.6709 15.7334C12.9298 13.4776 10.414 10.9612 8.15892 8.21942L8.97692 7.39942Z",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelphone);
export default __webpack_public_path__ + "static/media/telphone.104314bdbe8da7eded5b2120c62602b0.svg";
export { ForwardRef as ReactComponent };